/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Dpa_TitleInputs */

const en_legal_dpa_title = /** @type {(inputs: Legal_Dpa_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Processing Agreement`)
};

const pl_legal_dpa_title = /** @type {(inputs: Legal_Dpa_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umowa powierzenia przetwarzania danych`)
};

/**
* | output |
* | --- |
* | "Data Processing Agreement" |
*
* @param {Legal_Dpa_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_dpa_title = /** @type {((inputs?: Legal_Dpa_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Dpa_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_dpa_title(inputs)
	return en_legal_dpa_title(inputs)
});